/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Time limit in minutes (1-480)
 */
export type OpenExamRequestTimeLimitMinutes = number | null;
